export default "__VITE_ASSET__D08S$VL0__"